import React from "react";
import axios from "axios";
const API_URL = "https://billing.ourvds.ru";

class SoftwarePage extends React.Component {
  state = {
    software: []
  };
  componentDidMount() {
    const url = `${API_URL}/apiv1/addons/ispsystem`;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        this.setState({ software: data });
        console.log(this.state.software);
      });
  }

  render() {
    return (
      <div>
        <div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
          <h1 class="display-4">Лицензии ПО</h1>
          <p class="lead">Ну что? Пора запастись панелью управления! ;)</p>
        </div>
        <div class="container">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Название</th>
                  <th scope="col">Цена</th>
                  <th scope="col">Действие</th>
                </tr>
              </thead>
              <tbody>
                {this.state.software.map((soft) => (
                  <tr>
                    <th>{soft.name}</th>
                    <td>
                      {soft.cost}
                      {soft.costCurrency}
                    </td>
                    <td>
                      <a
                        class="btn btn-success"
                        href={`https://billing.ourvds.ru/billing.php?do=order&type=shop&item=${soft.id}&one=1`}
                      >
                        Заказать
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <hr />
        <div id="accordion">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Для чего требуется лицензия на ПО?
                </button>
              </h5>
            </div>

            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div class="card-body">
                На данный момент, есть ПО, которое предоставляется на
                коммерческой основе, данный вариант открывает возможности в
                использовании, и многое другое.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <button
                  class="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Какие в основном лицензии есть?
                </button>
              </h5>
            </div>
            <div
              id="collapseTwo"
              class="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordion"
            >
              <div class="card-body">
                У нас лицензии есть от следующих вендоров:
                <code>ISPSystem</code> :)
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <button
                  class="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Для чего требуется лицензия на ПО?
                </button>
              </h5>
            </div>

            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div class="card-body">
                На данный момент, есть ПО, которое предоставляется на
                коммерческой основе, данный вариант открывает возможности в
                использовании, и многое другое.
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <button
                  class="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Какие в основном лицензии есть?
                </button>
              </h5>
            </div>
            <div
              id="collapseTwo"
              class="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordion"
            >
              <div class="card-body">
                У нас лицензии есть от следующих вендоров:
                <code>ISPSystem</code> :)
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    );
  }
}
export default SoftwarePage;
